import React from 'react';

const AboutMain = () => {
  return (
    <>
      <style>
        {`
          /* Mobile-first styles */
          #about-main {
            position: relative;
            width: 100%;
            height: 60vh;
            overflow: hidden;
          }

          #about-main header {
            width: 100%;
            height: auto;
          }

          #about-main header .background {
            width: 100%;
            height: 400px;
            background-image: url('assets/images/images/2.jpg');
            background-size: cover;
            background-position: center;
          }

          #about-main .text-overlay {
            position: absolute;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            text-align: center;
            color: white;
          }

          #about-main h1 {
            font-size: 3rem;
            font-weight: 800;
            line-height: 1.2;
            letter-spacing: 0.05em;
          }

          #about-romesh {
            padding: 4rem 0;
            background-color: #f8f8f8;
            color: #2d3748;
          }

          #about-romesh .container {
            max-width: 1280px;
            margin: 0 auto;
            padding: 0 1.5rem;
          }

          #about-romesh .grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 4rem;
          }

          #about-romesh .bio {
            margin-bottom: 2rem;
          }

          #about-romesh h2 {
            font-size: 2rem;
            font-weight: 800;
            color: #1a202c;
            position: relative;
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            border-left: 4px solid transparent;
            transition: border-color 0.5s ease-in-out;
            line-height: initial;
          }

          #about-romesh .bio p {
            font-size: 1.125rem;
            color: #4a5568;
            line-height: 1.75;
          }

          .image-container {
            position: relative;
            border-radius: 0.5rem;
            overflow: hidden;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }

          .image-container img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .image-overlay {
            position: absolute;
            bottom: 1rem;
            left: 1rem;
            background-color: rgba(0, 0, 0, 0.5);
            color: white;
            padding: 0.5rem 1rem;
            border-radius: 9999px;
          }

          .image-overlay h3 {
            font-size: 1.25rem;
            font-weight: 600;
          }

          .cta-section {
            background-color: black;
            color: white;
            padding: 4rem 0;
            text-align: center;
          }

          .cta-section h2 {
            font-size: 1.875rem;
            font-weight: 600;
            margin-bottom: 1rem;
          }

          .cta-section p {
            font-size: 1.125rem;
            margin-bottom: 1.5rem;
          }

          .cta-button {
            background-color: white;
            color: black;
            padding: 0.5rem 1.5rem;
            border-radius: 9999px;
            font-size: 1.125rem;
            font-weight: 600;
            transition: background-color 0.3s ease;
          }

          .cta-button:hover {
            background-color: #e5e7eb;
          }

          /* Media Queries for Mobile */
          @media screen and (max-width: 768px) {
            #about-main h1 {
              font-size: 2rem;
            }

            #about-romesh .grid {
              grid-template-columns: 1fr;
              gap: 2rem;
            }

            #about-romesh .bio h2 {
              font-size: 1.5rem;
            }

            #about-romesh .bio p {
              font-size: 1rem;
            }

            .image-overlay h3 {
              font-size: 1rem;
            }

            .cta-section h2 {
              font-size: 1.5rem;
            }

            .cta-section p {
              font-size: 1rem;
            }

            .cta-button {
              font-size: 1rem;
            }
          }
        `}
      </style>

      <div className="div">
        {/* Header Section with Animated Video */}
        <section id="about-main">
          <header>
            <div className="background"></div>
          </header>
          <div className="text-overlay">
            <div>
              <h1>Welcome to Our Journey</h1>
            </div>
          </div>
        </section>

        {/* About Romesh Section */}
        <section id="about-romesh">
          <div className="container">
            <div className="grid">
              {/* Left Side - Bio */}
              <div className="bio">
                <h2>
                  Romesh Bhakte: Professional Event Photographer & Certified Drone Pilot
                  <span
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      height: '100%',
                      width: '4px',
                      backgroundColor: '#fbbf24',
                    }}
                  ></span>
                </h2>

                <p>
                Since 2022, Romesh Bhakte has been dedicated to creating timeless wedding films and photographs that preserve emotions, relationships, and once-in-a-lifetime moments. What began as a passion for photography has evolved into one of Central India’s growing luxury wedding storytelling brands.
                </p>

                <p>
                 With years of experience documenting weddings, pre-weddings, engagements, and destination celebrations, Romesh believes that every couple has a unique story worth telling. His work focuses on capturing genuine emotions, authentic moments, and cinematic visuals that remain meaningful for generations.
                </p>

                <p>
                 As a DGCA Certified Drone Pilot, Romesh seamlessly combines aerial cinematography with ground-level storytelling to create immersive wedding films. His technical expertise, creative direction, and attention to detail allow every project to achieve a premium cinematic look while maintaining the authenticity of the occasion.
                </p>
                <p>
                 Beyond filmmaking, Romesh is also the founder of GrowPeak Media, a creative marketing agency, where he has worked with businesses, brands, and entrepreneurs to produce high-quality visual content and digital campaigns. This experience has strengthened his understanding of branding, storytelling, production planning, and client experience—qualities that are reflected in every wedding project.
               Today, Romesh Bhakte Films is trusted by couples who value elegant visuals, emotional storytelling, and a seamless professional experience. Every wedding is approached with creativity, precision, and a commitment to delivering films and photographs that become cherished family heirlooms.
                </p>
                <p>For Romesh, photography isn’t simply about capturing how a wedding looked—it’s about preserving how it felt.</p>
              </div>

              {/* Right Side - Images */}
              <div>
                <div className="image-container">
                  <img
                    src="assets/images/IMG_3436.PNG"
                    alt="Romesh Bhakte"
                  />
                  <div className="image-overlay">
                    <h3>Romesh Bhakte</h3>
                    <p>Founder & Creative Director | Romesh Bhakte Films</p>
                  </div>
                </div>

                
              </div>
            </div>
          </div>
        </section>
        <section id="about-romesh">
          <div className="container">
            <div className="grid">
              {/* Left Side - img */}
          
              <div>
                <div className="image-container">
                  <img
                    src="assets/images/IMG_3432.PNG"
                    alt="Romesh Bhakte"
                  />
                  <div className="image-overlay">
                    <h3>Ankit Bhakte</h3>
                    <p>Co-Founder & Client Relationship Manager (CRM)</p>
                  </div>
                </div>

                
              </div>
              {/* Left Side - bio */}

                <div className="bio">
                <h2>
                  Ankit Bhakte: Co-Founder & Client Relationship Manager (CRM)
                  <span
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      height: '100%',
                      width: '4px',
                      backgroundColor: '#fbbf24',
                    }}
                  ></span>
                </h2>

                <p>
                Ankit Bhakte is the Co-Founder and Client Relationship Manager at Romesh Bhakte Films, ensuring every couple enjoys a seamless and memorable experience from the first inquiry to the final delivery.
                </p>

                <p>
                He oversees client communication, consultations, bookings, production coordination, scheduling, and post-production support. His organized approach and commitment to exceptional customer service help every wedding project run smoothly while maintaining the brand’s premium standards.
                </p>

                <p>
                 As the bridge between clients and the creative team, Ankit focuses on understanding each couple’s vision, managing expectations, and ensuring every detail is executed with professionalism, transparency, and care.
                </p>

                <p>
                 Together, Romesh and Ankit have built Romesh Bhakte Films with a shared vision—to create timeless wedding stories while providing an exceptional client experience built on trust, creativity, and excellence.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Ready to Capture Your Special Moments?</h2>
          <p>
            Let Romesh Bhakte bring your event to life with beautiful imagery and captivating aerial shots.
          </p>
          <a href="/contact" className="cta-button">
            Get In Touch
          </a>
        </section>
      </div>
    </>
  );
};

export default AboutMain;
